import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import React, { useMemo } from 'react';
import { useTranslate } from 'lib/translate';
import { capitalize } from 'helpers/content';
import { Editor } from "UI/Inputs";
import { Collapsible } from 'UI';
import { Icon } from '@haldor/ui';
import { ASSESSMENT_TYPES } from 'components/BlockAssessments/AssessmentTypes';

var AssessmentFeedbackField = function AssessmentFeedbackField(props) {
  var translate = useTranslate();
  var resource = props.resource;
  var initialValue = useMemo(function () {
    var _props$meta;

    if (props.meta != null && ((_props$meta = props.meta) === null || _props$meta === void 0 ? void 0 : _props$meta.initial) != null) {
      var _props$meta2;

      return JSON.parse(JSON.stringify((_props$meta2 = props.meta) === null || _props$meta2 === void 0 ? void 0 : _props$meta2.initial));
    }

    return null;
  }, []);
  /**
   * @param {number} index
   */

  var _getFieldInitialValue = function _getFieldInitialValue(index) {
    if (initialValue == null || initialValue.length == 0) {
      return null;
    }

    return initialValue[index];
  };
  /**
   * @param {number} index
   * @param {string} text
   */


  var _onValueTextChange = function _onValueTextChange(index, text) {
    var value = _toConsumableArray(props.input.value);

    value[index].text = text;
    props.input.onChange(value);
  };
  /**
   * @param {string} permission
   */


  var renderPermission = function renderPermission(permission, value) {
    var selected = false;

    if (!value.isPrivate && resource != null) {
      var _resource$permissions;

      selected = ((_resource$permissions = resource.permissions) === null || _resource$permissions === void 0 ? void 0 : _resource$permissions.find(function (element) {
        return element.target == permission && element.referenceType == 'ASSESSMENTFEEDBACK';
      })) != null;
    }

    return /*#__PURE__*/React.createElement("div", {
      className: "permission"
    }, selected ? /*#__PURE__*/React.createElement(Icon, {
      name: "Eye"
    }) : /*#__PURE__*/React.createElement(Icon, {
      name: "Eye_off"
    }), translate(capitalize(permission)));
  };
  /**
   * @returns {array}
   */


  var getValues = function getValues() {
    var value = props.input.value;

    if (resource == null) {
      return [];
    }

    if (value == null || value == '') {
      return [];
    }

    return value;
  };
  /**
   * @param {object} value
   * @param {number} index
   */


  var getValueTrigger = function getValueTrigger(value, index) {
    return /*#__PURE__*/React.createElement("div", {
      className: "df aic"
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        flex: 1
      }
    }, value.isPrivate ? translate('Personal note') : translate('Feedback')), props.assessmentType == ASSESSMENT_TYPES.TEACHER || props.assessmentType == null ? /*#__PURE__*/React.createElement("div", {
      className: "df aic"
    }, renderPermission('STUDENT', value), renderPermission('GUARDIAN', value)) : null);
  };

  var values = getValues();

  if (values.length == 0) {
    return null;
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "feedback-field"
  }, values.map(function (value, index) {
    if (resource.id != value.assessmentBlockPartId) {
      return null;
    }

    return /*#__PURE__*/React.createElement(Collapsible, {
      defaultOpen: true,
      key: index,
      trigger: getValueTrigger(value, index)
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Editor, {
      value: value.text,
      onChange: function onChange(text) {
        return _onValueTextChange(index, text);
      }
    })));
  }));
};

export default AssessmentFeedbackField;